module.exports = __webpack_public_path__ + "static/img/role.abe9e58.png";


//////////////////
// WEBPACK FOOTER
// ./static/default/img/role3/u/role.png
// module id = wUVl
// module chunks = 7